import {ReactNode} from "react";

import {useHiddenPricesRegistrationHandler} from "../../hooks/use_hidden_prices_registration_handler";
import {MainLeadDataPayload} from "../../lead/types/MainLeadDataPayload";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {ApplicationModalButton, IApplicationModalButtonRenderProps} from "./ApplicationModalButton";

export interface IApplicationModalButtonWithHiddenPricesRenderProps extends IApplicationModalButtonRenderProps {
    handleClick: () => void;
}

type IProps = {
    render: (props: IApplicationModalButtonWithHiddenPricesRenderProps) => ReactNode;
    shouldShowPrice: boolean;
    gtmData: IGTMEventLeadForm;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "gtmMeta">;

export const ApplicationModalButtonWithHiddenPrices = (props: IProps) => {
    const {render, shouldShowPrice, gtmData, ...applicationModalButtonProps} = props;

    return (
        <ApplicationModalButton
            {...applicationModalButtonProps}
            render={({openModal, isOpened}) => {
                const {handleClick} = useHiddenPricesRegistrationHandler({
                    onAction: () => openModal(gtmData),
                    shouldShowPrice,
                    gtmData,
                    propertyId: applicationModalButtonProps.propertyId,
                    offerId: applicationModalButtonProps.offerId
                });

                return render({openModal, isOpened, handleClick});
            }}
        />
    );
};
import {ReactNode} from "react";

import {useHiddenPricesRegistrationHandler} from "../../hooks/use_hidden_prices_registration_handler";
import {MainLeadDataPayload} from "../../lead/types/MainLeadDataPayload";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {ApplicationModalButton, IApplicationModalButtonRenderProps} from "./ApplicationModalButton";

export interface IApplicationModalButtonWithHiddenPricesRenderProps extends IApplicationModalButtonRenderProps {
    handleClick: () => void;
}

type IProps = {
    render: (props: IApplicationModalButtonWithHiddenPricesRenderProps) => ReactNode;
    shouldShowPrice: boolean;
    gtmData: IGTMEventLeadForm;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "gtmMeta">;

export const ApplicationModalButtonWithHiddenPrices = (props: IProps) => {
    const {render, shouldShowPrice, gtmData, ...applicationModalButtonProps} = props;

    return (
        <ApplicationModalButton
            {...applicationModalButtonProps}
            render={({openModal, isOpened}) => {
                const {handleClick} = useHiddenPricesRegistrationHandler({
                    onAction: () => openModal(gtmData),
                    shouldShowPrice,
                    gtmData,
                    propertyId: applicationModalButtonProps.propertyId,
                    offerId: applicationModalButtonProps.offerId
                });

                return render({openModal, isOpened, handleClick});
            }}
        />
    );
};
